var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.S_USER_PROFILE)?_c('div',{attrs:{"id":"user-profile"}},[_c('profile-header',{attrs:{"header-data":_vm.S_USER_PROFILE}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }